export const GRUPOS: 'groups' = 'groups';
export const ESTUDIANTES: 'estudiantes' = 'estudiantes';
export const FIREBASE_PREGUNTAS: 'preguntas' = 'preguntas';
export const FIREBASE_RESPUESTAS: 'respuestas' = 'respuestas';
export const FIREBASE_PROFESORES: 'profesores' = 'profesores';

export const REMOVE_STUDENT_GROUP: 'REMOVE_STUDENT_GROUP' = 'REMOVE_STUDENT_GROUP';

export const API_KEY = process.env.REACT_APP_BACKEND_URL;
